import type { FunctionComponent } from 'react';

import { DictionaryText, type PlainDictionaryTextProps } from '../../dictionary/reactBindings/DictionaryText';
import { UITranslations } from '../UITranslations';

export interface L10nTextProps extends PlainDictionaryTextProps {}

export const L10nText: FunctionComponent<L10nTextProps> = ({ ...rest }) => {
  return <DictionaryText service={UITranslations} {...rest} />;
};
